import React, { useState } from 'react'

const HomeFeatures = () => {

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <>
            <div id="main-div">
                <h2 id="home-page-features-heading">Features</h2>
                <div className="btn-div">
                    <button style={{ backgroundColor: `${activeIndex === 0 ? 'rgb(15 105 115)' : 'rgb(245 160 140)'}` }} className="btn" onClick={() => { setActiveIndex(0) }}>Manage Hours <div className={(activeIndex === 0) ? 'triangle' : ''}></div> </button>
                    <button style={{ backgroundColor: `${activeIndex === 1 ? 'rgb(15 105 115)' : 'rgb(245 160 140)'}` }} className="btn" onClick={() => { setActiveIndex(1) }}>Reporting & Analytics <div className={(activeIndex === 1) ? 'triangle' : ''}></div> </button>
                    <button style={{ backgroundColor: `${activeIndex === 2 ? 'rgb(15 105 115)' : 'rgb(245 160 140)'}` }} className="btn" onClick={() => { setActiveIndex(2) }}>Payroll Integration <div className={(activeIndex === 2) ? 'triangle' : ''}></div> </button>
                    <button style={{ backgroundColor: `${activeIndex === 3 ? 'rgb(15 105 115)' : 'rgb(245 160 140)'}` }} className="btn" onClick={() => { setActiveIndex(3) }}>Overtime Calculation <div className={(activeIndex === 3) ? 'triangle' : ''}></div> </button>
                </div>

                <div className="chat-bubble">
                    <div style={{ display: `${activeIndex === 0 ? 'block' : 'none'}` }} id="goutContent" className="feature-content">
                        <div className="flex-div-feature">
                            <div className="left-div-feature">
                                <h1>Record and Manage Your Work Hours Effectively</h1>
                                <p>Our Time Tracking feature allows employees to accurately log their daily work hours,
                                    including precise start and end times, breaks taken, and total hours worked. This
                                    comprehensive tracking ensures accurate calculations for payroll and compliance with
                                    labor regulations, helping organizations adhere to legal standards and streamline their
                                    operations.</p>
                                <ul>
                                    <li>Track daily work hours with detailed start and end time entries for each day.</li>
                                    <li>Automatically record breaks and calculate total hours worked to minimize errors.
                                    </li>
                                    <li>Generate detailed reports to assist with accurate payroll processing and ensure
                                        compliance with employment laws.</li>
                                    <li>Seamlessly integrate with labor law regulations to ensure that all tracking meets
                                        legal requirements and organizational standards.</li>
                                </ul>

                            </div>
                            <div className="right-div-feature">
                                <img src="/images/1.png" alt="dsd" />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: `${activeIndex === 1 ? 'block' : 'none'}` }} id="otherContent1" className="feature-content">
                        <div className="flex-div-feature">
                            <div className="left-div-feature">
                                <h1>Flexible Reporting and Analytics</h1>
                                <p>Gain valuable insights with our flexible reporting and analytics tools. The timesheet
                                    feature includes customizable reports that provide a clear view of hours worked, project
                                    progress, and employee productivity. Users can generate daily, weekly, or monthly
                                    reports to make informed decisions and optimize workflow.</p>
                                <ul>
                                    <li>Access highly customizable reports to track detailed hours worked and analyze the
                                        progress of various projects, tailored to meet your specific reporting needs.</li>
                                    <li>Monitor employee productivity with in-depth reporting options that provide a
                                        comprehensive view of performance trends and areas for improvement.</li>
                                    <li>Generate and review reports on a daily, weekly, or monthly basis, allowing for
                                        flexible scheduling and better alignment with your reporting requirements.</li>
                                    <li>Utilize advanced analytics to optimize workflow, streamline operations, and make
                                        data-driven decisions that enhance overall organizational efficiency.</li>
                                </ul>
                            </div>
                            <div className="right-div-feature">
                                <img src="/images/1.png" alt="dsd" />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: `${activeIndex === 2 ? 'block' : 'none'}` }} id="otherContent2" className="feature-content">
                        <div className="flex-div-feature">
                            <div className="left-div-feature">
                                <h1>Seamless Integration with Payroll Systems</h1>
                                <p>Integrate your timesheet data effortlessly with your payroll system. Our feature ensures
                                    that all recorded hours are accurately transferred to your payroll software, reducing
                                    manual data entry and minimizing errors. This integration streamlines payroll processing
                                    and ensures timely and accurate payments.</p>
                                <ul>
                                    <li>Effortlessly integrate timesheet data with your payroll system for smooth data
                                        transfer and minimal manual entry.</li>
                                    <li>Reduce errors by ensuring accurate and automatic transfer of recorded hours to
                                        payroll software.</li>
                                    <li>Streamline payroll processing to enhance efficiency and ensure timely, accurate
                                        payments to employees.</li>
                                    <li>Minimize manual data entry and eliminate potential discrepancies for a more reliable
                                        payroll system.</li>
                                </ul>
                            </div>
                            <div className="right-div-feature">
                                <img src="/images/1.png" alt="Seamless Integration" />
                            </div>
                        </div>

                    </div>
                    <div style={{ display: `${activeIndex === 3 ? 'block' : 'none'}` }} id="otherContent3" className="feature-content">
                        <div className="flex-div-feature">
                            <div className="left-div-feature">
                                <h1>Automated Overtime Calculation</h1>
                                <p>Our time tracking system includes an automated overtime calculation feature that
                                    simplifies the process of tracking and managing overtime hours. This feature
                                    automatically calculates overtime pay based on your company’s specific rules and rates,
                                    ensuring accurate compensation and compliance with labor laws.</p>
                                <ul>
                                    <li>Automatically calculate overtime hours based on pre-defined rules and rates to
                                        ensure accurate compensation.</li>
                                    <li>Reduce manual calculations and potential errors with automated overtime tracking.
                                    </li>
                                    <li>Ensure compliance with labor laws by adhering to company-specific overtime policies
                                        and regulations.</li>
                                    <li>Streamline payroll processes with accurate overtime data integrated into your
                                        overall time tracking system.</li>
                                </ul>
                            </div>
                            <div className="right-div-feature">
                                <img src="/images/1.png" alt="Automated Overtime Calculation" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default HomeFeatures
